import { IColumn } from "shared/ui/Table/constants";

export const columns: IColumn[] = [
  {
    label: "Directorate ID",
    field: "id",
  },
  {
    label: "Directorate Name",
    field: "name",
  },
  {
    label: "Employee count",
    field: "attachedEmployeeCount",
  },
];
